module.exports = __webpack_public_path__ + "img/estrellas.5ed3a09d.svg";